import { Extension } from '@tiptap/core'
import { getStyleAttrName } from '@/services/forms/tmTiptap/extensions/tmTiptapHtmlStylesHandlerExtension'
import { verifyTmTiptapEditor } from '@/services/forms/tmTiptap/extensions/utils'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    tmBackgroundColor: {
      setColor: (color: string) => ReturnType
      unsetColor: () => ReturnType
      setBgColor: (color: string) => ReturnType
      unsetBgColor: () => ReturnType
    }
  }
}

export const TmTextColorCommandsExtension = Extension.create({
  name: 'tmBackgroundColor',

  addCommands() {
    return {
      setColor:
        (color: string) =>
        ({ chain, editor: editorParam }) => {
          const editor = verifyTmTiptapEditor(editorParam)
          const currentNode = editor.getNodeUnderCaret()
          const hasLink = currentNode ? currentNode.marks.some((mark) => mark.type.name === 'link') : false

          if (hasLink) {
            return chain()
              .updateAttributes('link', { [getStyleAttrName('color')]: color })
              .setTextStyle({ [getStyleAttrName('color')]: color })
              .run()
          }

          return chain()
            .setTextStyle({ [getStyleAttrName('color')]: color })
            .run()
        },
      unsetColor:
        () =>
        ({ chain }) =>
          chain()
            .setTextStyle({ [getStyleAttrName('color')]: 'initial' })
            .run(),

      setBgColor:
        (color: string) =>
        ({ chain }) =>
          chain()
            .setTextStyle({ [getStyleAttrName('backgroundColor')]: color })
            .run(),
      unsetBgColor:
        () =>
        ({ chain }) =>
          chain()
            .setTextStyle({ [getStyleAttrName('backgroundColor')]: 'initial' })
            .run(),
    }
  },
})
